import { ReactNode } from 'react';
import dynamic from 'next/dynamic';
import {
	PUBLIC_APP_INSIGHTS_KEY_ENV,
    PUBLIC_GTM_ID_ENV,
	PUBLIC_FF_HEADER_BASKET_ICON,
} from 'tools/environments';
import { GetFooterResponse } from 'services/mancity-template/get/types/get-footer.type';
import { GetMainNavResponse } from 'services/mancity-template/get/types/get-main-nav.type';
import { GetPartnerLogosResponse } from 'services/mancity-template/get/types/get-partner-logos.type';

const ManCityTemplate = dynamic(() => import('core/mancity/template'), { ssr: false });

type LayoutProps = {
    children: ReactNode;
	footerData?: GetFooterResponse;
	mainNavData?: GetMainNavResponse;
	partnersData?: GetPartnerLogosResponse;
};

const analyticsConfig = {
    gtmId: PUBLIC_GTM_ID_ENV,
    applicationInsightsConnectionString: PUBLIC_APP_INSIGHTS_KEY_ENV,
};

export const Layout = ({ children, footerData, mainNavData, partnersData }: LayoutProps) => {
	const navItems =
        mainNavData?.find(({ navgroup }) => navgroup === 'primary')?.items ||
        [];

	return (
		<>
			<ManCityTemplate
				headerNavigationData={navItems}
				partnersData={partnersData}
				footerData={footerData}
				config={analyticsConfig}
				showBasketIcon={PUBLIC_FF_HEADER_BASKET_ICON}
			>
				{children}
			</ManCityTemplate>
		</>
	);
};
